
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import qs from 'qs';

import { mesAutobind } from '@posco/posco-shared';
import { ContentLayout, Popout, Button } from '@posco/posco-ui-react';
import ItemView from '../view/ItemView';


@inject('itemStore', 'itemUiStore')
@mesAutobind
@observer
class ItemContainer extends Component {
  //
  componentDidMount() {
    //
    const { match, location, itemUiStore } = this.props;
    const itemNoParam = match.params.itemNo;

    if (itemNoParam) {
      this.findItem(itemNoParam);
    }

    if (location) {
      const searchParams = qs.parse(location.search, { ignoreQueryPrefix: true });

      if (searchParams.folding === 'true') {
        itemUiStore.setFolding(true);
      }
    }
  }

  componentWillUnmount() {
    this.props.itemStore.clearItem();
  }

  findItem(itemNo) {
    this.props.itemStore.findItem(itemNo);
  }

  linkToList() {
    this.props.history.push(`/items`);
  }

  handleConfirm() {
    Popout.confirmAndClose('Confirmed');
  }


  render() {
    //
    const { itemStore, itemUiStore } = this.props;
    const { item } = itemStore;

    return (
      <ContentLayout>
        <ContentLayout.Header
          title={`Item ${item && item.itemNo ? ` > ${item.itemNo}` : ''}`}
        />

        <ItemView
          item={item}
          folding={itemUiStore.folding}
        />

        <Button onClick={this.handleConfirm}>확인</Button>
      </ContentLayout>
    );
  }
}

export default ItemContainer;
